<template lang="pug">
    component.slide(v-if="image" :is="tag" v-bind="props")
      figure
        img(
          v-lazy="image"
          :style="{ width: `${width}px`, height: `${height}px` }"
          rel="noopener"
        )
        .text-wrapper(v-if="title || sub_title || text" :style="style")
          h2(v-if="title") {{ title }}
          h3(v-if="sub_title") {{ sub_title }}
          p(v-if="text" v-html="text")
          router-link.more-link(
              v-if="path"
              :to="path"
          )
              | {{ linkText }}
          a.more-link(
              v-else-if="href"
              :href="href"
              :title="slide.title || slide.sub_title"
              :target="target"
          )
              | {{ linkText }}
</template>

<script>
import { get, trim } from '@/helpers';

export default {
    name: 'Slide',
    data() {
        return {
            delay: 0,
            mouseover: false
        };
    },
    props: {
        slide: {
            type: Object,
            required: true
        },
        maxWidth: {
            type: Number,
            required: true
        },
        maxHeight: {
            type: Number,
            required: true
        }
        // imageLoaded: {
        //     type: Boolean,
        //     default: false,
        // }
    },
    computed: {
        tag() {
            let tag = 'div';
            if (this.path) tag = 'router-link';
            else if (this.href) tag = 'a';
            return tag;
        },
        props() {
            let props = {};

            switch (this.tag) {
                case 'a':
                    props.href = this.href;
                    props.target = this.target;
                    break;

                case 'router-link':
                    props.to = this.path;
                    break;
            }

            return props;
        },
        image() {
            const image = get(this.slide, 'images.0');
            if (!image) return false;

            if (!this.maxWidth || !this.maxHeight) return false;

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
            const parameters = {
                ...get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
            };
            // let { w, h, fx, fy, fz } = parameters;
            let { fx, fy, fz } = parameters;

            let width, height, aspectRatio;

            width = image.width / fz;
            height = image.height / fz;
            aspectRatio = width / height;

            // // height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height);
            // // width = height * aspectRatio;
            //
            // if (maxWidth < width) {
            //   height = maxWidth / aspectRatio;
            //   height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height);
            //   width = height * aspectRatio;
            // }

            // if (w && h) {
            //   aspectRatio = w / h;
            //
            //   height = Math.min(window.innerWidth >= 1088 ? 400 : 140, image.height / fz);
            //   width = height * aspectRatio;
            //
            //   if (this.maxWidth < width) {
            //     height = this.maxWidth / aspectRatio;
            //     height = Math.min(window.innerWidth >= 1088 ? 400 : 140, image.height / fz);
            //     width = height * aspectRatio;
            //   }
            //
            //   fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`);
            // } else if (!w && !h) {
            //   fit += `&h=${height}`;
            // }

            if (!fx) fx = 0.5;
            if (!fy) fy = 0.5;
            if (!fz) fz = 1;

            // fit: cover

            width = this.maxWidth;
            height = this.maxHeight;
            aspectRatio = width / height;

            fit = `fit=crop&crop=focalpoint&x=${fx}&y=${fy}&z=${fz}&w=${width}&h=${height}`;

            // TODO:
            // fit: contain

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio
            };
        },
        width() {
            if (this.image.width) return Math.min(this.maxWidth, this.image.width);
            else return undefined;
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio;
            else return undefined;
        },
        hyperlink() {
            return get(this.slide, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },
        linkText() {
            return get(this.hyperlink, 'name') || 'mehr...';
        },
        title() {
            return get(this.slide, 'title');
        },
        sub_title() {
            return get(this.slide, 'sub_title');
        },
        text() {
            return get(this.slide, 'text');
        },
        style() {
            let style = {};

            if (this.slide.color) {
                let color;
                if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(this.slide.color)) {
                    color = this.slide.color.substring(1).split('');
                    if (color.length == 3) {
                        color = [color[0], color[0], color[1], color[1], color[2], color[2]];
                    }
                    color = '0x' + color.join('');
                    style.background =
                        'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',0.5)';
                } else style.background = 'rgba(222,222,222,0.5)';
            }
            return style;
        }
    }
};
</script>

<style lang="sass" scoped>
figure
  .text-wrapper
    background-color: #dedede
    position: absolute
    bottom: 0
    padding: 15px 35px
    backdrop-filter: blur(4px)
    h2
      color: #fff
      font-size: 24px
      font-weight: 500
    h3
      color: #fff
      font-size: 18px
      font-weight: 400
    p
      color: #fff
      font-weight: 400
    .more-link
      color: #fff
  img
    object-fit: cover
</style>
